
import React from 'react';

const HiringManagerInsights: React.FC = () => {
  const insights = [
    {
      title: "Impact > Certification",
      text: "I don't care if you have 12 certifications if you can't explain how you saved the company money or improved uptime."
    },
    {
      title: "The 'How' Matters",
      "text": "Seniors don't just solve problems; they create systems that solve whole classes of problems."
    },
    {
      title: "Blast Radius Awareness",
      text: "Juniors deploy and pray. Seniors explain the fallback strategy, the monitoring plan, and the blast radius mitigation before hitting enter."
    }
  ];

  return (
    <section className="py-20 px-6 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <h2 className="text-4xl font-bold mb-6">Real Expectations <br/> <span className="text-orange-500">From Hiring Managers</span></h2>
          <p className="text-slate-400 mb-8 text-lg">
            What actually happens behind closed doors during promotion cycles and calibration meetings.
          </p>
          <div className="space-y-6">
            {insights.map((insight, i) => (
              <div key={i} className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center text-orange-400 font-bold border border-slate-700">
                  {i + 1}
                </div>
                <div>
                  <h4 className="font-bold text-slate-100 mb-1">{insight.title}</h4>
                  <p className="text-slate-400 text-sm leading-relaxed">{insight.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <div className="absolute -inset-4 bg-orange-500/20 blur-3xl rounded-full"></div>
          <div className="relative glass border-slate-700 p-8 rounded-3xl">
            <div className="font-mono text-sm text-orange-400 mb-4"># Internal_Calibration_Leaked.txt</div>
            <div className="space-y-4 text-slate-300 font-mono text-xs md:text-sm">
              <p className="flex gap-2"><span className="text-slate-500">01</span> [VP_Eng]: "Does he own the VPC networking or does it own him?"</p>
              <p className="flex gap-2"><span className="text-slate-500">02</span> [Dir_Platform]: "She standardized our Terraform modules. 40% dev speedup."</p>
              <p className="flex gap-2"><span className="text-slate-500">03</span> [Manager]: "Great technical skill, but still waits for tickets. Not Senior yet."</p>
              <p className="flex gap-2"><span className="text-slate-500">04</span> [Staff_Eng]: "Promote. He automated his own job twice in 6 months."</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HiringManagerInsights;
